module.exports = __webpack_public_path__ + "static/media/Plexus_Innovation_Logo.701fd158.svg";